// ORDER_HUD_FACE_LEGIBILITY_1 r1 R4 (HUDCHAT-47): the expiry tide's two time labels are drawn only when they fit.
// The first label is anchored start at the plot's left edge and the last anchored end at its right edge; on a
// narrow tile (the INDEX tide at 390 px) they overprinted as one garbled string. When both do not fit, only the
// last is drawn: the newest minute is the one a reader needs.

/** The gap the two labels keep between them, in px. */
export const EXPIRY_TIDE_TIME_GAP_PX = 8;
/** A 9 px numeric label's advance per character, in em (the face's tabular digits measure about 0.62 em). */
export const EXPIRY_TIDE_CHAR_EM = 0.62;

export type ExpiryTideTimeFit = "BOTH" | "LAST";

/**
 * HIDDEN-TIDE-SKIP-1 (R7168): a panel under display:none (the cockpit behind the focus layout, App.svelte's .cockpit-hidden)
 * measures clientWidth 0. It is hidden, not broken: it draws nothing and logs nothing. Any other width is drawn,
 * so a visible tile too narrow to plot, or a NaN measurement, still reaches tideTimeX and its refusal stays loud.
 */
export function expiryTideHidden(measuredWidth: number): boolean {
  return measuredWidth === 0;
}

export function expiryTideTimeLabels(input: {
  plotLeft: number;
  plotRight: number;
  firstText: string;
  lastText: string;
  charPx: number;
  gapPx: number;
}): ExpiryTideTimeFit {
  const { plotLeft, plotRight, firstText, lastText, charPx, gapPx } = input;
  for (const [name, value] of [["plotLeft", plotLeft], ["plotRight", plotRight], ["charPx", charPx], ["gapPx", gapPx]] as const) {
    if (!Number.isFinite(value)) throw new RangeError(`expiry tide axis: ${name} must be finite; received ${value}`);
  }
  const need = firstText.length * charPx + gapPx + lastText.length * charPx;
  return need <= plotRight - plotLeft ? "BOTH" : "LAST";
}
